import testFavicon from '@/assets/img/test_favicon.png'
import prodFavicon from '@/assets/img/prod_favicon.png'
import preFavicon from '@/assets/img/pre_favicon.png'

// 请求地址配置
const http = {
	development: {
		prefix: '',
		host: 'http://dev-api-ndesigner-admin.idatachain.cn'
	},
	production: {
		prefix: '',
		host: 'http://shiquaner-admin-api.zookingsoft.com'
	},
	preRelease: {
		prefix: '',
		host: 'http://120.27.22.130:8083'
	}
}

// 根据不同环境显示不同favicon
const favicon = {
	development: testFavicon,
	production: prodFavicon,
	preRelease: preFavicon
}

// 前端狮圈环境变量
const shiQuan = {
	development: {
		url: 'http://dev-shiquaner.idatachain.cn/#'
	},
	preRelease: {
		url: 'http://120.27.22.130:8080/#'
	},
	production: {
		url: 'https://www.shiquaner.com/#'
	}
}

let env = 'development'

if(window.location.host == 'shiquaner-admin.zookingsoft.com') {
	env = 'production'

}else if(window.location.host == '120.27.22.130:8082') {
	env = 'preRelease'
}

export const httpConfig = http[env]
export const shiQuanConfig = shiQuan[env]
export const faviconConfig = favicon[env]
